import { execAdmin } from '../utils';

import type { CatalogUploadData } from './getCatalogUploads';

interface GetCatalogUploadVariables {
  id: number;
}

export interface CatalogUploadPhaseProgress {
  status: string;
  percentage: number;
  processedCount?: number;
  totalCount?: number;
  isRequired?: boolean;
}

export interface CatalogUploadProgress {
  overallStatus: string;
  catalogUpload: CatalogUploadPhaseProgress;
  algoliaSync: CatalogUploadPhaseProgress;
  shopifySync: CatalogUploadPhaseProgress;
}

export interface CatalogUploadDetail {
  id: number;
  title: string | null;
  source: string | null;
  sourcePartner: string | null;
  uploadStatus: string | null;
  date: string | null;
  initiatedBy: string | null;
  totalRecords: number | null;
  hasOriginalFile: boolean | null;
  data: CatalogUploadData | null;
  progress: CatalogUploadProgress | null;
}

interface GetCatalogUploadResponse {
  catalogUpload: CatalogUploadDetail;
}

const CATALOG_UPLOAD_QUERY = `
  query catalogUpload($id: Int!) {
    catalogUpload(id: $id) {
      id
      title
      source
      sourcePartner
      uploadStatus
      date
      initiatedBy
      totalRecords
      hasOriginalFile
      data
      progress {
        overallStatus
        catalogUpload {
          status
          percentage
          processedCount
          totalCount
        }
        algoliaSync {
          status
          percentage
        }
        shopifySync {
          status
          percentage
          isRequired
        }
      }
    }
  }
`;

export const getCatalogUpload = async (id: number): Promise<CatalogUploadDetail> => {
  const data = await execAdmin<GetCatalogUploadVariables, GetCatalogUploadResponse>(
    CATALOG_UPLOAD_QUERY,
    { variables: { id } },
  );
  return data.catalogUpload;
};
